import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    autenticado:JSON.parse(localStorage.getItem('auth_rom') || false),
    api:'',
    api_public:'',
    usuario: JSON.parse(localStorage.getItem('user_rom') || false),
    menus_rom: JSON.parse(localStorage.getItem('menus_rom') || false),
    token: JSON.parse(localStorage.getItem('token_rom') || false),
    cabeceras_json: JSON.parse(localStorage.getItem('cabecera_rom') || false),
    cabeceras_archivo:null,
    columnas:[],
    filtros_rom:JSON.parse(localStorage.getItem('filtros_rom') || false),
    botones:[],
    botones_restringidos:[],
    lista:[],
    links:[],
    inputs:[],
    acciones:[],
    titulo_menu:'no',
    permisos_rom:JSON.parse(localStorage.getItem('permisos_rom') || false),
    roles_rom:JSON.parse(localStorage.getItem('roles_rom') || false),
    username:null,
    password:null
  },
  mutations: {
    setear_sesion(state,payload){
      localStorage.setItem("auth_rom",JSON.stringify({auth:true}));
      localStorage.setItem("token_rom",JSON.stringify({token:payload.token}));
      localStorage.setItem("user_rom",JSON.stringify(payload.user));
      localStorage.setItem("menus_rom",JSON.stringify(payload.menus));
      localStorage.setItem("permisos_rom",JSON.stringify(payload.permisos));
      localStorage.setItem("roles_rom",JSON.stringify(payload.roles));
      localStorage.setItem("cabecera_rom",JSON.stringify({
          'headers':{
            'Content-Type':'application/json;charset=utf-8',
            'Authorization':`${payload.token}`
          }
        }
      ));

      localStorage.setItem("cabecera_archivo_rom",JSON.stringify({
        'headers':{
          'Content-Type':'multipart/form-data',
          'Authorization':`${payload.token}`
        }
      }));
      


      state.autenticado = JSON.parse(localStorage.getItem("auth_rom")).auth;
      state.token = JSON.parse(localStorage.getItem("token_rom")).token;
      state.usuario = JSON.parse(localStorage.getItem("user_rom"));
      state.menus_rom = JSON.parse(localStorage.getItem("menus_rom"));
      state.permisos_rom = JSON.parse(localStorage.getItem("permisos_rom"));
      state.roles_rom = JSON.parse(localStorage.getItem("roles_rom"));
      state.cabeceras_json = JSON.parse(localStorage.getItem("cabecera_rom"));
      state.cabeceras_archivo = JSON.parse(localStorage.getItem("cabecera_archivo_rom"));


      /* state.autenticado = true;
      state.usuario = payload.user;
      state.token = payload.token;
      state.menus = payload.menus;
      state.permisos = payload.permisos;
      state.cabeceras_json = {
        'headers':{
          'Content-Type':'application/json;charset=utf-8',
          'Authorization':`${state.token}`
        }
      };
      state.cabeceras_archivo = {
        'headers':{
          'Content-Type': 'multipart/form-data',
          'Authorization':`${state.token}`
        }
      }; */
      
      ////console.log('pauyload',payload);
    },
    setear_api(state,bases){
      state.api = bases.api;
      state.api_public = bases.api_public;
    },
    salir(state){
      console.log('six2');

      localStorage.removeItem("auth_rom");
      localStorage.removeItem("token_rom");
      localStorage.removeItem("user_rom");
      localStorage.removeItem("menus_rom");
      localStorage.removeItem("permisos_rom");
      localStorage.removeItem("roles_rom");
      localStorage.removeItem("cabecera_rom");
      localStorage.removeItem("cabecera_archivo_rom");



      state.autenticado = false;
      state.usuario = null;
      state.token = '';
      state.menus_rom = [];
      state.permisos_rom = [];
      state.roles_rom = [];
      state.cabeceras_json = null;
      state.cabeceras_archivos = null;
    },
    iniciar_tabla(state,data){
      state.columnas = data.columnas;
      state.lista = data.lista;
      state.links = data.links;
      state.botones = data.botones;
      state.botones_restringidos = data.botones_restringidos? data.botones_restringidos : [];
      state.acciones = data.acciones?data.acciones:[];
    },
    actualizar_lista(state,data){
      state.lista = data.lista;
      state.links = data.links;
    },
    inicializar_inputs(state,inputs){
      state.inputs = inputs;
    },
    actualizar_titulo_menu(state,titulo){
      state.titulo_menu = titulo;
    },
    activar_desactivar_menu(state,menu){
      let activo = !menu.activo;
      ////console.log('menucito',menu);
      
      state.menus_rom.forEach((m,idx) => {
        state.menus_rom[idx].activo = false;
        ////console.log('menu'+idx,state.menus[idx]);
        m.submenus.forEach((s,i)=>{
          state.menus_rom[idx].submenus[i].activo = false;
        })
      });

      ////console.log('menues',state.menus);

      if(menu.debajo_de != null){
        let index_padre = state.menus_rom.findIndex(m => m.id == menu.debajo_de);
        let index_submenu = state.menus_rom[index_padre].submenus.findIndex(m=>m.id == menu.id);
        state.menus_rom[index_padre].submenus[index_submenu].activo = activo;
      }else{
        let index = state.menus_rom.findIndex(m => m.id == menu.id);
        state.menus_rom[index].activo = activo;
        ////console.log('index',index,'menu',state.menus[index]);
      }
    },
    actualizar_credenciales(state,payload){
      state.username = payload.username;
      state.password = payload.password;
      //console.log('credenciales guardadas',state.username,state.password);
    },
  },
  actions: {
    iniciarSesion({commit,state},datos){
      commit('setear_sesion',datos)
    },
    actualizar_base({commit,state},bases){
      commit('setear_api',bases)
    },
    cerrar_sesion({commit,state}){
      //console.log('si');
      commit('salir')
    },
    inicializar_tabla({commit,state},datos){
      commit('iniciar_tabla',datos)
    },
    setear_lista({commit,state},datos){
      commit('actualizar_lista',datos)
    },
    setear_inputs({commit,state},datos){
      commit('inicializar_inputs',datos)
    },
    actualizar_titulo({commit,state},titulo){
      ////console.log('titulo',titulo);
      commit('actualizar_titulo_menu',titulo)
    },
    actualizar_menu({commit,state},menu){
      ////console.log('menudito',menu)
      commit('activar_desactivar_menu',menu)
    },
    cambiar_credenciales({commit,state},datos){
      commit('actualizar_credenciales',datos)
    },
  },
  modules: {
  },
  plugins: [createPersistedState({
    paths: ['usuario','username','password','permisos','menus','api','api_public','autenticado','token','cabeceras_json','cabeceras_archivo','titulo_menu']
  })]
})
